import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ Restore access token before React mounts
const savedToken = sessionStorage.getItem('accessToken');
if (savedToken && !window.accessToken) {
  window.accessToken = savedToken;
  console.log("✅ Restored access token before React render");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
